import React from 'react';

export interface ListaIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

const ListaIcon: React.FC<ListaIconProps> = ({ 
  size = 24, 
  color = 'currentColor',
  className = '' 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.334 6.662h13m-13 6h13m-13 6h13m-18-12h.01m-.01 6h.01m-.01 6h.01"/>
    </svg>
  );
};

export default ListaIcon;
